import { gql } from "@apollo/client";

export const REMOVE_ORGANIZATION_FROM_INITIATIVE = gql`
  mutation Mutation(
    $initiativeId: String!
    $organizationId: String!
    $organizationIdToRemove: String!
  ) {
    removeFromInitiative(
      initiativeId: $initiativeId
      organizationId: $organizationId
      organizationIdToRemove: $organizationIdToRemove
    ) {
      success
    }
  }
`;
